// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    portfolioCollections: "Portfolio Collections",
    pageDescription:
      "Manage portfolio collections - each collection contains portfolios for different risk scores",
    documentation: "Documentation",
  },
  nb_NO: {
    settings: "Innstillinger",
    portfolioCollections: "Porteføljesamlinger",
    pageDescription:
      "Administrer porteføljesamlinger - hver samling inneholder porteføljer for ulike risikoskårer",
    documentation: "Dokumentasjon",
  },
} as const;
